// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel[data-v-f252c3dc] {\n  height: 100%;\n}\n.panel .chart-box[data-v-f252c3dc] {\n  width: 100%;\n  height: 100%;\n}\n.panel .echarts-img[data-v-f252c3dc] {\n  height: 1.25rem;\n  margin: 0 auto;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
